"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.updatePhysicsTick = exports.updatePhysics_networked = exports.updatePhysics_localhost = exports.onRapierLoaded = exports.timestep = exports.isLoaded = exports.get = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
var crokinolePucks_sidecar_1 = require("../entities/crokinolePucks-sidecar");
var crokinoleCamera_sidecar_1 = require("../main/crokinoleCamera-sidecar");
var crokinoleDefs_sidecar_1 = require("../main/crokinoleDefs-sidecar");
var crokinoleRenderer_sidecar_1 = require("../main/crokinoleRenderer-sidecar");
var crokinolePhysics_contactHandler_sidecar_1 = require("./crokinolePhysics_contactHandler-sidecar");
var namespace = 'physics_rapier_loader';
Promise.resolve().then(function () { return __importStar(require('@dimforge/rapier2d-compat')); }).then(function (RAPIER) {
    exports.onRapierLoaded(RAPIER);
});
var _obj = null;
function get() {
    assert_sidecar_1.assert.notNil(_obj, 'rapier not loaded');
    return _obj;
}
exports.get = get;
function isLoaded() {
    return _obj !== null;
}
exports.isLoaded = isLoaded;
exports.timestep = 1 / 120;
// export const timestep = 1 / 60
// export const timestep = 1 / 30
// export const timestep = 1 / 101
var onRapierLoaded = function (asyncRAPIER) { return __awaiter(void 0, void 0, void 0, function () {
    var loadedRAPIER, RA, gravity, world, eventQueue, turn, wallThickness, wallLength, worldSize, CollisionGroups, physicsMultiplier, playAreaRadius, holeSensorRadius, placerSensorRadius, poleRadius, puckRadius, squareBoundaryMultipliers, squareSizes, borderAdjust, i, squareOffset, boundary_rigidBodyDesc, boundary_rigidBody, boundary_colliderDesc, boundary_collider, angleBoundaryMultipliers, i, angleOffset, boundary_rigidBodyDesc, boundary_rigidBody, boundary_colliderDesc, boundary_collider, playarea_rigidBodyDesc, playArea_rigidBody, playArea_colliderDesc, playArea_collider, poles, i, offset, rot, ox, oy, rigidBodyDescPole, pole, colliderDescPole, colliderPole, rigidBodyDescSensor, holeSensor, colliderDescSensor, colliderSensor, placerSensor_rigidBodyDesc, placerSensor_rigidBody, placerSensor_colliderDesc, placerSensor_collider, rigidBodyDescKnocker, knocker, colliderDescKnocker, colliderKnocker;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                console.log(namespace, 'onRapierLoaded');
                return [4 /*yield*/, asyncRAPIER.default];
            case 1:
                loadedRAPIER = _a.sent();
                RA = loadedRAPIER;
                gravity = { x: 0.0, y: 0.0 };
                world = new RA.World(gravity);
                world.timestep = exports.timestep;
                eventQueue = new RA.EventQueue(true);
                turn = Math.PI * 2;
                wallThickness = crokinoleDefs_sidecar_1.crokinoleDefs.wallThickness, wallLength = crokinoleDefs_sidecar_1.crokinoleDefs.wallLength, worldSize = crokinoleDefs_sidecar_1.crokinoleDefs.worldSize, CollisionGroups = crokinoleDefs_sidecar_1.crokinoleDefs.CollisionGroups, physicsMultiplier = crokinoleDefs_sidecar_1.crokinoleDefs.physicsMultiplier, playAreaRadius = crokinoleDefs_sidecar_1.crokinoleDefs.playAreaRadius, holeSensorRadius = crokinoleDefs_sidecar_1.crokinoleDefs.holeSensorRadius, placerSensorRadius = crokinoleDefs_sidecar_1.crokinoleDefs.placerSensorRadius, poleRadius = crokinoleDefs_sidecar_1.crokinoleDefs.poleRadius, puckRadius = crokinoleDefs_sidecar_1.crokinoleDefs.puckRadius;
                squareBoundaryMultipliers = [
                    [-1, 0],
                    [0, 1],
                    [1, 0],
                    [0, -1],
                ];
                squareSizes = [
                    [wallThickness, wallLength],
                    [wallLength, wallThickness],
                    [wallThickness, wallLength],
                    [wallLength, wallThickness],
                ];
                borderAdjust = wallThickness / 2 + wallThickness * 0.135;
                for (i = 0; i < 4; i++) {
                    squareOffset = worldSize / 2 + borderAdjust;
                    boundary_rigidBodyDesc = RA.RigidBodyDesc.fixed().setTranslation(squareBoundaryMultipliers[i][0] * squareOffset, squareBoundaryMultipliers[i][1] * squareOffset);
                    boundary_rigidBody = world.createRigidBody(boundary_rigidBodyDesc);
                    boundary_colliderDesc = RA.ColliderDesc.cuboid(squareSizes[i][0] / 2, squareSizes[i][1] / 2);
                    boundary_collider = world.createCollider(boundary_colliderDesc, boundary_rigidBody);
                    boundary_collider.setCollisionGroups(CollisionGroups.playarea + CollisionGroups.gutter);
                    boundary_rigidBody.userData = { type: 'boundary' };
                }
                angleBoundaryMultipliers = [
                    [-1, 1],
                    [1, 1],
                    [1, -1],
                    [-1, -1],
                ];
                for (i = 0; i < 4; i++) {
                    angleOffset = (worldSize / 2) * 0.7441;
                    boundary_rigidBodyDesc = RA.RigidBodyDesc.fixed()
                        .setTranslation(angleOffset * angleBoundaryMultipliers[i][0], angleOffset * angleBoundaryMultipliers[i][1])
                        .setRotation((turn * 1) / 8 + (turn * i) / 4);
                    boundary_rigidBody = world.createRigidBody(boundary_rigidBodyDesc);
                    boundary_colliderDesc = RA.ColliderDesc.cuboid(wallLength / 2, wallThickness / 2);
                    boundary_collider = world.createCollider(boundary_colliderDesc, boundary_rigidBody);
                    boundary_collider.setCollisionGroups(CollisionGroups.playarea + CollisionGroups.gutter);
                    boundary_rigidBody.userData = { type: 'boundary' };
                }
                playarea_rigidBodyDesc = RA.RigidBodyDesc.fixed().setTranslation(0, 0);
                playArea_rigidBody = world.createRigidBody(playarea_rigidBodyDesc);
                playArea_colliderDesc = RA.ColliderDesc.ball(playAreaRadius)
                    .setRestitution(0.8)
                    .setFriction(0.25);
                playArea_collider = world.createCollider(playArea_colliderDesc, playArea_rigidBody);
                playArea_collider.setCollisionGroups(CollisionGroups.gutter);
                playArea_rigidBody.userData = { type: 'playarea' };
                poles = [];
                for (i = 0; i < 8; i++) {
                    offset = (103 + 0.7) * physicsMultiplier;
                    rot = (turn * i) / 8 + (turn * 1) / 16;
                    ox = Math.cos(rot) * offset;
                    oy = Math.sin(rot) * offset;
                    rigidBodyDescPole = RA.RigidBodyDesc.fixed().setTranslation(ox, oy);
                    pole = world.createRigidBody(rigidBodyDescPole);
                    colliderDescPole = RA.ColliderDesc.ball(poleRadius).setRestitution(0.9);
                    colliderPole = world.createCollider(colliderDescPole, pole);
                    colliderPole.setCollisionGroups(CollisionGroups.playarea);
                    pole.userData = { type: 'pole' }; // TODO: link to data
                    poles.push(pole);
                }
                rigidBodyDescSensor = RA.RigidBodyDesc.fixed().setTranslation(0.0, 0.0);
                holeSensor = world.createRigidBody(rigidBodyDescSensor);
                colliderDescSensor = RA.ColliderDesc.ball(holeSensorRadius).setSensor(true);
                colliderSensor = world.createCollider(colliderDescSensor, holeSensor);
                holeSensor.userData = { type: 'hole' };
                placerSensor_rigidBodyDesc = RA.RigidBodyDesc.fixed().setTranslation(0.0, 0.0);
                placerSensor_rigidBody = world.createRigidBody(placerSensor_rigidBodyDesc);
                placerSensor_colliderDesc = RA.ColliderDesc.ball(placerSensorRadius)
                    .setSensor(true)
                    .setCollisionGroups(CollisionGroups.playarea);
                placerSensor_collider = world.createCollider(placerSensor_colliderDesc, placerSensor_rigidBody);
                placerSensor_rigidBody.userData = { type: 'placer' };
                rigidBodyDescKnocker = RA.RigidBodyDesc.kinematicPositionBased().setTranslation(5.0, 5.0);
                knocker = world.createRigidBody(rigidBodyDescKnocker);
                colliderDescKnocker = RA.ColliderDesc.ball(puckRadius);
                colliderKnocker = world.createCollider(colliderDescKnocker, knocker);
                colliderKnocker.setCollisionGroups(
                // CollisionGroups.playarea + CollisionGroups.gutter,
                CollisionGroups.inactive);
                knocker.userData = { type: 'knocker' };
                _obj = {
                    RA: RA,
                    world: world,
                    // puck1,
                    // puck2,
                    knocker: knocker,
                    poles: poles,
                    holeSensor: holeSensor,
                    placerSensor: placerSensor_rigidBody,
                    elapsedSeconds: 0,
                    eventQueue: eventQueue,
                    physicsStepsSimulatedCount: 0,
                };
                console.log(namespace, 'onRapierLoaded', 'complete');
                return [2 /*return*/];
        }
    });
}); };
exports.onRapierLoaded = onRapierLoaded;
var updatePhysics_localhost = function (elapsedSeconds) {
    if (!isLoaded()) {
        return;
    }
    // console.log(namespace, 'updatePhysics1', get().elapsedSeconds, elapsedSeconds)
    var maxSteps = 10;
    if (elapsedSeconds > exports.timestep * maxSteps) {
        elapsedSeconds = exports.timestep * maxSteps;
    }
    get().elapsedSeconds += elapsedSeconds;
    while (get().elapsedSeconds >= exports.timestep) {
        exports.updatePhysicsTick(true, false);
        get().elapsedSeconds -= exports.timestep;
    }
    // console.log(namespace, 'updatePhysics2', get().elapsedSeconds, elapsedSeconds)
    exports.updatePhysicsTick(false, true);
};
exports.updatePhysics_localhost = updatePhysics_localhost;
var updatePhysics_networked = function (steps) {
    if (!isLoaded()) {
        return;
    }
    var i = 0;
    while (i < steps) {
        i++;
        exports.updatePhysicsTick(true, false);
    }
    // console.log(namespace, 'updatePhysics2', get().elapsedSeconds, elapsedSeconds)
    exports.updatePhysicsTick(false, true);
};
exports.updatePhysics_networked = updatePhysics_networked;
var updatePhysicsTick = function (step, render) {
    if (!isLoaded()) {
        return;
    }
    var physicsMultiplier = crokinoleDefs_sidecar_1.crokinoleDefs.physicsMultiplier, CollisionGroups = crokinoleDefs_sidecar_1.crokinoleDefs.CollisionGroups;
    // console.log(namespace, 'updatePhysicsTick')
    var _a = get(), world = _a.world, knocker = _a.knocker, poles = _a.poles, sensor = _a.holeSensor, placerSensor = _a.placerSensor, eventQueue = _a.eventQueue;
    var cursor = voyageCamera_sidecar_1.voyageCamera.getUiMousePosition();
    var physicsCursor = crokinoleCamera_sidecar_1.crokinoleCamera.worldToPhysics(cursor.mx, cursor.my);
    // TODO: only apply on step?
    // TODO: move fling elsewhere
    // if (clickEater.isLeftFirstDownRegardless()) {
    //   let cursorToPuck1Delta = {
    //     x: physicsCursor.x - puck1.translation().x,
    //     y: physicsCursor.y - puck1.translation().y,
    //   }
    //   let impulseMultiplier = 0.05
    //   puck1.applyImpulse(
    //     {
    //       x: cursorToPuck1Delta.x * -impulseMultiplier,
    //       y: cursorToPuck1Delta.y * -impulseMultiplier,
    //     },
    //     true,
    //   )
    //   // puck1.applyTorqueImpulse(0.01, true)
    // }
    if (step) {
        crokinolePucks_sidecar_1.crokinolePucks.updateAllPhysicsTick();
        knocker.setTranslation({ x: physicsCursor.x, y: physicsCursor.y }, true);
        placerSensor.setTranslation({ x: physicsCursor.x, y: physicsCursor.y }, true);
    }
    // Step the simulation forward.
    if (step) {
        get().physicsStepsSimulatedCount++;
        world.step(eventQueue);
        crokinolePhysics_contactHandler_sidecar_1.crokinolePhysics_contactHandler.processPhysicsEventQueue(eventQueue);
    }
    if (render) {
        crokinoleRenderer_sidecar_1.crokinoleRenderer.render();
    }
};
exports.updatePhysicsTick = updatePhysicsTick;
